'use client';

// `useNetworkAwarePath()` — companion to `<Link>` for IMPERATIVE
// navigation (`router.push`, `router.replace`, server-component
// `redirect`). Returns a function that takes a bare path and returns
// the right URL for the user's current mode:
//
//   mode = mainnet  →  path returned as-is
//   mode = devnet   →  `/demo-mode/<path>` (when path is demo-aware)
//   excepted paths  →  always returned as-is (about, learn, terms, …)
//
// Usage:
//
//   const networkPath = useNetworkAwarePath();
//   router.push(networkPath('/markets'));
//
// Why not just call `addDemoModePath()` directly? Because that helper
// doesn't know the user's mode — it just adds the prefix
// unconditionally. This hook is the imperative counterpart to
// `<NetworkLink>`: it applies the same rule, in the same place, so
// `router.push(...)` and `<Link href=...>` produce identical URLs for
// the same target.
import { c as _c } from "react/compiler-runtime";
import { addDemoModePath, isDemoModeAwarePath } from './preference';
import { useNetworkMode } from './use-network-mode';
export type NetworkAwarePath = (bareHref: string) => string;
export function useNetworkAwarePath() {
  const $ = _c(2);
  const mode = useNetworkMode();
  let t0;
  if ($[0] !== mode) {
    t0 = bareHref => {
      if (mode === "mainnet") {
        return bareHref;
      }
      if (!isDemoModeAwarePath(bareHref)) {
        return bareHref;
      }
      return addDemoModePath(bareHref);
    };
    $[0] = mode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}